import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow bg-background">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <h1 className="text-4xl font-bold mb-8 text-primary">Obchodné podmienky</h1>

          <div className="prose prose-slate max-w-none space-y-6 text-foreground">
            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">1. Základné ustanovenia</h2>
              <p>
                Tieto obchodné podmienky (ďalej len "OP") upravujú vzťahy medzi poskytovateľom
                služby <strong>TagInn</strong> (ďalej len "Poskytovateľ") a užívateľom služby
                (ďalej len "Zákazník").
              </p>
              <p className="mt-4">
                Poskytovateľ prevádzkuje platformu TagInn - komplexný SaaS systém pre správu malých
                a stredných podnikov, ktorý zahŕňa nástroje pre riadenie zamestnancov, zmeny,
                komunikáciu, recenzie zákazníkov, vernostné programy a ďalšie funkcie.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">2. Vymedzenie pojmov</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong>Služba</strong> - SaaS platforma TagInn a všetky jej funkcie dostupné na webovej stránke</li>
                <li><strong>Zákazník</strong> - fyzická alebo právnická osoba, ktorá uzavrela zmluvu s Poskytovateľom</li>
                <li><strong>Používateľský účet</strong> - účet vytvorený Zákazníkom na prístup k Službe</li>
                <li><strong>Predplatné</strong> - platený alebo bezplatný prístup k Službám podľa zvoleného plánu</li>
                <li><strong>Mesačný poplatok</strong> - pravidelná platba za používanie Služby podľa cenníka</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">3. Vznik zmluvného vzťahu</h2>
              <p>
                Zmluvný vzťah vzniká registráciou Zákazníka na platforme TagInn a vytvorením
                používateľského účtu. Zákazník registráciou potvrdzuje, že:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Je spôsobilý na právne úkony</li>
                <li>Súhlasí s týmito obchodnými podmienkami</li>
                <li>Poskytol pravdivé a aktuálne údaje</li>
                <li>Súhlasí so spracovaním osobných údajov podľa <Link to="/privacy" className="text-primary hover:underline">Zásad ochrany osobných údajov</Link></li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">4. Práva a povinnosti Poskytovateľa</h2>
              <p><strong>Poskytovateľ sa zaväzuje:</strong></p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Poskytovať Službu v dohodnutom rozsahu a kvalite</li>
                <li>Zabezpečiť dostupnosť Služby minimálne 99% času (okrem plánovanej údržby)</li>
                <li>Ochraňovať osobné údaje Zákazníka v súlade s GDPR</li>
                <li>Poskytovať technickú podporu</li>
                <li>Priebežne vylepšovať a aktualizovať Službu</li>
                <li>Informovať Zákazníka o dôležitých zmenách v Službe</li>
              </ul>

              <p className="mt-6"><strong>Poskytovateľ má právo:</strong></p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Pozastaviť prístup k Službe pri porušení OP alebo nezaplatení poplatkov</li>
                <li>Vykonávať pravidelnú údržbu systému (s predchádzajúcim upozornením)</li>
                <li>Upraviť rozsah a funkcie Služby</li>
                <li>Zmeniť cenník s mesačným predstihom</li>
                <li>Ukončiť poskytovanie Služby pri závažnom porušení OP</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">5. Práva a povinnosti Zákazníka</h2>
              <p><strong>Zákazník sa zaväzuje:</strong></p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Používať Službu v súlade s platnými právnymi predpismi</li>
                <li>Neposkyovať prístupové údaje tretím osobám</li>
                <li>Zabezpečiť ochranu svojho hesla a prihlasovacích údajov</li>
                <li>Hradiť dohodnuté poplatky za Službu včas a v plnej výške</li>
                <li>Informovať Poskytovateľa o akýchkoľvek bezpečnostných incidentoch</li>
                <li>Nepoužívať Službu spôsobom, ktorý by mohol poškodiť systém alebo iných používateľov</li>
                <li>Aktualizovať svoje údaje v prípade zmeny</li>
              </ul>

              <p className="mt-6"><strong>Zákazník má právo:</strong></p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Používať Službu podľa zvoleného predplatného plánu</li>
                <li>Kedykoľvek ukončiť používanie Služby</li>
                <li>Požadovať export svojich dát</li>
                <li>Obrátiť sa na technickú podporu</li>
                <li>Požadovať vymazanie svojich údajov po ukončení služby</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">6. Platobné podmienky</h2>

              <div className="bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg p-4 mb-6">
                <p className="font-semibold text-blue-900 dark:text-blue-100">
                  ℹ️ Služba je momentálne dostupná bezplatne
                </p>
                <p className="text-sm text-blue-800 dark:text-blue-200 mt-2">
                  Platforma TagInn je v testovacej fáze. V budúcnosti budú niektoré funkcie spoplatnené.
                </p>
              </div>

              <p>
                Plánované cenové plány:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li><strong>Free</strong> - bezplatný plán s obmedzenými funkciami</li>
                <li><strong>Starter</strong> - základný platený plán</li>
                <li><strong>Professional</strong> - rozšírený plán s pokročilými funkciami</li>
                <li><strong>Enterprise</strong> - plán pre veľké podniky s maximálnymi možnosťami</li>
              </ul>

              <p className="mt-6">
                <strong>Platobné podmienky:</strong>
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Platby sú spracovávané prostredníctvom platobnej brány Stripe</li>
                <li>Mesačný poplatok je splatný vždy k prvému dňu v mesiaci</li>
                <li>Pri nezaplatení poplatku môže byť prístup k Službe pozastavený</li>
                <li>Ceny sú uvedené v EUR vrátane DPH</li>
                <li>Zmena cenníka je možná s mesačným predstihom</li>
                <li>Zrušenie predplatného je možné kedykoľvek, bez vrátenia poplatku za prebiehajúce obdobie</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">7. Ochrana údajov a bezpečnosť</h2>
              <p>
                Poskytovateľ sa zaväzuje chrániť údaje Zákazníka v súlade s:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Nariadením GDPR (General Data Protection Regulation)</li>
                <li>Zákonom č. 18/2018 Z. z. o ochrane osobných údajov</li>
                <li>Platnými bezpečnostnými štandardmi</li>
              </ul>

              <p className="mt-4">
                Poskytovateľ vykonáva pravidelné zálohovanie dát. Zákazník je však zodpovedný
                za svoje vlastné zálohy dôležitých údajov.
              </p>

              <p className="mt-4">
                Viac informácií nájdete v našich <Link to="/privacy" className="text-primary hover:underline">Zásadách ochrany osobných údajov</Link>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">8. Zodpovednosť a obmedzenia</h2>
              <p>
                Poskytovateľ nezodpovedá za:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Škody spôsobené nesprávnym používaním Služby Zákazníkom</li>
                <li>Stratu dát spôsobenú Zákazníkom alebo treťou stranou</li>
                <li>Výpadky služby spôsobené vyššou mocou</li>
                <li>Škody vzniknuté porušením OP zo strany Zákazníka</li>
                <li>Škody spôsobené neoprávneným prístupom tretích osôb</li>
              </ul>

              <p className="mt-6">
                Zodpovednosť Poskytovateľa je obmedzená na výšku poplatkov zaplatených Zákazníkom
                za posledných 12 mesiacov.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">9. Trvanie a ukončenie zmluvy</h2>
              <p>
                Zmluva sa uzatvára na dobu neurčitú a možno ju ukončiť:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li><strong>Zákazníkom</strong> - kedykoľvek zrušením predplatného v používateľskom účte</li>
                <li><strong>Poskytovateľom</strong> - pri závažnom porušení OP s 30-dňovou výpovednou lehotou</li>
                <li><strong>Okamžite</strong> - pri porušení zákonov alebo zneužití Služby</li>
              </ul>

              <p className="mt-4">
                Po ukončení zmluvy:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Zákazník stráca prístup k Službe</li>
                <li>Poskytovateľ uchováva dáta 30 dní na export</li>
                <li>Po 30 dňoch sú dáta natrvalo vymazané (okrem zákonnej archivačnej povinnosti)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">10. Duševné vlastníctvo</h2>
              <p>
                Všetky práva duševného vlastníctva k Službe, vrátane:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Zdrojového kódu</li>
                <li>Dizajnu a grafiky</li>
                <li>Obchodného mena a loga</li>
                <li>Dokumentácie</li>
              </ul>
              <p className="mt-4">
                zostávajú výhradným vlastníctvom Poskytovateľa. Zákazník získava len nevýhradnú
                licenciu na používanie Služby v súlade s týmito OP.
              </p>

              <p className="mt-4">
                Údaje vkladané Zákazníkom zostávajú jeho vlastníctvom. Poskytovateľ má právo
                ich spracovávať len na účely poskytovania Služby.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">11. Záverečné ustanovenia</h2>
              <p>
                Tieto obchodné podmienky nadobúdajú platnosť a účinnosť dňom ich zverejnenia
                na webovej stránke. Poskytovateľ si vyhradzuje právo tieto OP zmeniť. O zmenách
                bude Zákazník informovaný e-mailom minimálne 30 dní vopred.
              </p>

              <p className="mt-4">
                Vzťahy neupravené týmito OP sa riadia:
              </p>
              <ul className="list-disc pl-6 mt-4 space-y-2">
                <li>Zákonom č. 40/1964 Zb. (Občiansky zákonník)</li>
                <li>Zákonom č. 513/1991 Zb. (Obchodný zákonník)</li>
                <li>Zákonom č. 18/2018 Z. z. (o ochrane osobných údajov)</li>
                <li>Nariadením GDPR</li>
              </ul>

              <p className="mt-6">
                Prípadné spory budú riešené prednostne dohodou. V prípade súdneho sporu je
                príslušný súd podľa sídla Poskytovateľa.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4 text-primary">12. Kontaktné údaje</h2>
              <div className="space-y-2">
                <p><strong>TagInn</strong></p>
                <p>Slovenská republika</p>
                <p>Email: <a href="mailto:info@taginn.app" className="text-primary hover:underline">info@taginn.app</a></p>
                <p>Telefón: +421 902 691 939</p>
              </div>
            </section>

            <p className="text-sm text-muted-foreground mt-8">
              Tieto obchodné podmienky sú platné a účinné od {new Date().toLocaleDateString('sk-SK')}
            </p>
          </div>

          <div className="mt-8">
            <Link to="/" className="text-primary hover:underline">
              ← Späť na hlavnú stránku
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
